<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:31:30
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的报名</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.Title"
            placeholder="输入关键词搜索"
          />
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <ul class="my-tabs">
        <li
          class="my-tabs-item"
          :class="{ active: getListData.StatusID == item.value }"
          @click="changeTabs(item)"
          v-for="(item, index) in tabs"
          :key="index"
        >
          {{ item.label }}
        </li>
      </ul>
      <el-table
        v-loading="isLoading"
        :data="tableData"
      >
        <el-table-column prop="date" label="报名名称">
          <template slot-scope="scope">
            <p class="bmName">{{ scope.row.Title }}</p>
            <p class="time">
              {{ scope.row.EnrollTime }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ClassifyName"
          label="类型"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="StatusID"
          label="状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span class="StatusID">{{ scope.row.StatusTxt }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="400" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldDetail(scope.row)">
              查看
            </el-button>
            <el-button
              v-if="scope.row.StatusID == 0"
              class="table-btn"
              @click="toPay(scope.row)"
            >
              缴费
            </el-button>
            <el-button
              v-if="scope.row.StatusID == 0"
              class="table-btn"
              @click="cancel(scope.row)"
            >
              取消
            </el-button>
            <el-button
              v-if="scope.row.StatusID == 2"
              class="table-btn"
              @click="application(scope.row)"
            >
              重新报名
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
      <el-dialog
        title="我的报名信息"
        :visible.sync="dialogShow"
        class="width510"
        :append-to-body="true"
      >
        <div class="my-form">
          <div
            v-for="(item, index) in formList"
            :key="index"
            class="mt-form-item"
          >
            <div class="label">
              {{ item.FiledName }}
              <span class="must">({{ item.IsMust ? "必填" : "非必填" }})</span>
            </div>
            <el-input
              :disabled="showType == 1"
              v-if="item.FiledType == 1"
              v-model="item.SubContent"
            ></el-input>
            <el-select
              v-else
              :disabled="showType == 1"
              v-model="item.SubContent"
              placeholder=""
            >
              <el-option
                v-for="(it, i) in item.Options"
                :key="i"
                :label="it"
                :value="it"
              />
            </el-select>
          </div>
        </div>
        <div v-if="showType == 0" slot="footer">
          <el-button class="submit-btn" @click="submit()">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Enroll_GetFileds,
  Enroll_UserSubEnroll,
  Enroll_UserCancelrEnroll,
  GetMyEnrollDetail,
  GetMyEnrollList,
} from "@/api/member";
import { CreateOrders } from "@/api/order";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "application",
  data() {
    return {
      showType: 0, //0:报名 1:查看
      SubjectID: 0,
      dialogShow: false,
      formList: [],
      tabs: [
        { label: "全部", value: -1 },
        { label: "待缴费", value: 0 },
        { label: "已完成", value: 1 },
        { label: "已取消", value: 2 },
      ],
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        StatusID: -1,
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    submit() {
      const data = {
        SubjectID: this.SubjectID,
        SubItems: this.formList,
      };
      Enroll_UserSubEnroll(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('报名成功');
          this.dialogShow = false;
          this.getList();
        } else {
          
        }
      });
    },
    changeTabs(item) {
      this.getListData.StatusID = item.value;
      this.getList();
    },
    hanldDetail(data) {
      GetMyEnrollDetail({
        EUID: data.EUID,
        SubjectID: data.SubjectID,
      }).then((res) => {
        this.SubjectID = data.SubjectID;
        this.showType = 1;
        this.dialogShow = true;
        this.formList = res.data;
      });
    },
    toPay(data) {
      this.$router.push({
        path: "/confirmOrder",
        query: {
          OrdersID: data.OrdersID,
        },
      });
    },
    cancel(data) {
      this.$confirm("此操作将取消报名, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        customClass: "my-messagebox",
      }).then(() => {
        Enroll_UserCancelrEnroll({
          EUID: data.EUID,
          SubjectID: data.SubjectID,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.dialogShow = false;
            this.getList();
          } else {
            
          }
        });
      });
    },
    application(data) {
      Enroll_GetFileds({
        SubjectID: data.SubjectID,
      }).then((res) => {
        this.SubjectID = data.SubjectID;
        this.showType = 0;
        this.dialogShow = true;
        this.formList = res.data.map((item) => {
          item.SubContent = "";
          return item;
        });
      });
    },
    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetMyEnrollList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.bmName {
  font-size: 20px;
  color: #333333;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.time {
  margin-top: 5px;
  font-size: 16px;
  color: #666666;
}
.StatusID {
  font-size: 16px;
  color: #1d79ff;
}
.my-form {
  .mt-form-item {
    margin-bottom: 20px;
    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }
    .must {
      color: #ef3d3d;
    }
  }
  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
}
.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
